import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  ElementRef,
  ViewChild,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { GetOrderListService } from './api-services/get-order-list.service';
import { OrderTextWithCatalogModel } from './order-text-with-catalog.model';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';

/**
 * 受注コードテキストインプットクラス
 *
 * @export OrderTextWithCatalogComponent
 * @class OrderTextWithCatalogComponent
 */
@Component({
  selector: 'app-order-text-with-catalog',
  templateUrl: 'order-text-with-catalog.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OrderTextWithCatalogComponent,
      multi: true,
    },
    {
      provide: GetOrderListService,
      useFactory: (
        plessHttp: PlessHttp,
        dialogService: PlessDialogServiceSub
      ) => {
        return new GetOrderListService(plessHttp, dialogService);
      },
      deps: [PlessHttp, PlessDialogServiceSub],
    },
  ],
})
export class OrderTextWithCatalogComponent
  implements OnInit, AfterViewInit, OnChanges, ControlValueAccessor
{
  /** テキストインプットの参照 */
  @ViewChild('inputText', { static: true }) public inputText: ElementRef;
  /** ngModelバインディング用変数 */
  public text: string = null;
  @Input() public subid: string = null;
  /** 初期フォーカス項目 */
  @Input() public initFocusItem: any = null;
  /** 登録サイクルフィールド */
  @Input() public registCycleField: any = null;
  /** 初期フォーカス */
  @Input() public autofocus: boolean = <boolean>false;

  // レイアウト系の変数
  @Input() public width: number | string; // どちらでも受けてTemplateに判断させる
  @Input() public height: number = <number>20;
  @Input() public fontSize: number = <number>9;
  @Input() public editable: boolean = <boolean>true;
  @Input() public tabindex: number = <number>-1;
  @Input() public tabEnabled: boolean = <boolean>true;
  @Input() public forcedEnabledMode: string;
  @Input() public required: boolean = <boolean>false;

  @Output() onChangedCatalogId = new EventEmitter<string>();

  /** 受注コードテキストインプットモデル */
  public model: OrderTextWithCatalogModel = new OrderTextWithCatalogModel();

  private written = false;

  // ValueAccessor
  @Input() public disabled: boolean = <boolean>false;
  public onChange(obj: any): void {}
  public onTouched(): void {}
  public writeValue(text: string): void {
    if (text !== this.text) {
      this.text = text;
      this.written = true;
    }
  }
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /**
   * Creates an instance of OrderTextWithCatalogComponent.
   * private getOrderListService: GetOrderListService,
   * @param {GetOrderListService} getOrderListService 受注コードリストを取得する
   * @memberof CatalogProgressTextInputComponent
   */
  constructor(
    private getOrderListService: GetOrderListService,
    public elementRef: ElementRef
  ) {}

  /**
   * 初期化処理
   *
   * @memberof OrderTextWithCatalogComponent
   */
  public ngOnInit(): void {
    this.inputText.nativeElement.setAttribute('id', this.subid + '_sub');
    this.inputText.nativeElement.setAttribute(
      'forcedEnabledMode',
      this.forcedEnabledMode ?? ''
    );
  }

  /**
   * ロード完了時
   *
   * @memberof OrderTextWithCatalogComponent
   */
  public ngAfterViewInit(): void {
    // テキストインスタンス設定
    this.model.orderCodeTextInput = this;

    // イベント発行
    this.getOrderListService.execute(this.model);
  }

  /**
   * 値変更時イベント
   *
   * @param {SimpleChanges} changes 変更イベント
   * @memberof OrderTextWithCatalogComponent
   */
  public ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach(propName => {
      switch (propName) {
        case 'text':
          this.text = changes.text.currentValue;

          if (this.model.completeUpdateOrderCodeList) {
            // 変更イベント処理実行
            this.changeOrderCodeHandler();
          }
          break;
      }
    });
  }

  /**
   * 受注コード有効有無を返却する
   *
   * @return boolean:True有効、False無効
   */
  public isValidOrderCode(): boolean {
    return !PlessViewUtilsSub.isEmpty(this.model.selectedCatalogId);
  }

  /*
  /**
   * 受注コードを設定する
   *
   * @param orderCode:受注コード
   */
  public setOrderCode(orderCode: string): void {
    this.text = orderCode;
    if (this.initFocusItem != null) {
      this.initFocusItem.focus();
      this.initFocusItem = null;
    }

    this.changeOrderCodeHandler();
  }

  /**
   * 受注コード変更時の処理を行う。
   */
  public changeOrderCodeHandler(): void {
    if (this.model.selectedCatalogId) {
      this.onChangedCatalogId.emit(this.model.selectedCatalogId);
    } else if (!this.written) {
      this.onChangedCatalogId.emit('');
    }
    this.written = false;
  }

  /**
   * setFocus Override※テキスト選択解除の為
   */
  public setFocus(): void {
    this.inputText.nativeElement.focus();
  }
}
